import { captureRemixErrorBoundaryError } from "@sentry/remix";

/** Report a Remix route error boundary error to Sentry. */
export function reportRouteError(error: unknown) {
  captureRemixErrorBoundaryError(error);
}
